/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AdminProjectsControllerDeleteTokenAllocationV1$Params {
  projectId: string;
  allocationId: string;
}

export function adminProjectsControllerDeleteTokenAllocationV1(http: HttpClient, rootUrl: string, params: AdminProjectsControllerDeleteTokenAllocationV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
'allocationId'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, adminProjectsControllerDeleteTokenAllocationV1.PATH, 'delete');
  if (params) {
    rb.path('projectId', params.projectId, {});
    rb.path('allocationId', params.allocationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'message'?: string;
      'allocationId'?: string;
      }>;
    })
  );
}

adminProjectsControllerDeleteTokenAllocationV1.PATH = '/v1/admin/projects/{projectId}/token-allocations/{allocationId}';
